module.exports = __webpack_public_path__ + "static/img/rda.de2b272.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_supporters/rda.jpg
// module id = V2UA
// module chunks = 1